<template>
  <div id="app">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <link href="https://use.typekit.net/suk3yiz.css"  rel='stylesheet' type='text/css'>
    <link href="https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap" rel="stylesheet">
    
      <router-view />
      <div style="display: none;" class="modal-custom" id="refresh_token_retry">
        <div class="loader-img-center">
          <i class="fa fa-spinner fa-spin"></i> Please wait while we refresh your session...
        </div>
      </div>
      <portal-target name="chart-tooltip-root" multiple />
  </div>


</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from './store/store';

export default {
  name: 'App',

  created() {

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue